import { render, staticRenderFns } from "./SingleAccreditedBuilder.vue?vue&type=template&id=e3e21eb6"
import script from "./SingleAccreditedBuilder.vue?vue&type=script&lang=ts"
export * from "./SingleAccreditedBuilder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports